import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AcceptInviteFacade, AcceptInviteUiState } from './accept-invite.facade';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { GlobalMessageService } from '../../global-services/global-message.service';

@Component({
  selector: 'app-accept-invite',
  imports: [...COMMON_IMPORTS, CommonModule, ButtonModule, CardModule, ProgressSpinnerModule],
  templateUrl: './accept-invite.component.html',
  styleUrls: ['./accept-invite.component.css']
})
export class AcceptInviteComponent implements OnInit {
  uiState$ = this.facade.uiState$;

  constructor(
    private route: ActivatedRoute,
    public facade: AcceptInviteFacade,
    private messageService: GlobalMessageService,
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token');
    if (!token) {
      console.error('Invite token is missing from the URL.');
      this.messageService.showError('No URL', 'Invite token is missing from the URL.', 3000);
      return;
    }

    this.facade.load(token);
  }

  cancelInvite(): void {
    // Renamed from cancelPressed
    this.facade.inviteCancelled();
  }

  acceptInvite(): void {
    this.facade.acceptInvite();
  }

  signInAndAccept(): void {
    this.facade.navigateToSignIn();
  }

  signUpAndAccept(): void {
    this.facade.navigateToSignUp();
  }
}
